import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import store from './store'
import router from './router'
import { ElMessage } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import './assets/fonts.css'


const app = createApp(App)

app.config.globalProperties.$message = ElMessage

app.use(store)
app.use(router)
app.use(ElementPlus, {
    locale: zhCn,
  })

app.mount('#app')
